var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import DownloadButton from '../components/download-button';
const useLessonPlans = ({ manageLessonsPlans, idLesson, modules = [], colorIconDownload }) => {
    const [dataLessonsPlans, setDataLessonsPlans] = useState([]);
    const [originalDataLessonsPlans, setOriginalDataLessonsPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const { getClient, currentUserSession } = useUserSesssion();
    const client = getClient();
    const subscription = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription;
    const isTrial = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === 'trialing';
    const getDataClient = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setLoading(true);
        const response = yield manageLessonsPlans.findLessonPlansByClient(client === null || client === void 0 ? void 0 : client.id);
        if (response && Array.isArray(response)) {
            const idLessonFirstLesson = (_b = (_a = modules[0]) === null || _a === void 0 ? void 0 : _a.lessons[0]) === null || _b === void 0 ? void 0 : _b.lessonId;
            const items = response.map(item => {
                var _a, _b, _c;
                if (isTrial) {
                    const hasCommonElements = (_a = item === null || item === void 0 ? void 0 : item.lessonsplansLessons) === null || _a === void 0 ? void 0 : _a.map(i2 => i2.lessonId).includes(idLessonFirstLesson);
                    return {
                        id: item === null || item === void 0 ? void 0 : item.id,
                        name: item === null || item === void 0 ? void 0 : item.name,
                        description: item === null || item === void 0 ? void 0 : item.description,
                        Lessons: ((_b = item === null || item === void 0 ? void 0 : item.lessonsplansLessons) === null || _b === void 0 ? void 0 : _b.length) || 0,
                        download: React.createElement(DownloadButton, { item: item, disabled: !hasCommonElements, colorIcon: colorIconDownload })
                    };
                }
                else {
                    return {
                        id: item === null || item === void 0 ? void 0 : item.id,
                        name: item === null || item === void 0 ? void 0 : item.name,
                        description: item === null || item === void 0 ? void 0 : item.description,
                        Lessons: ((_c = item === null || item === void 0 ? void 0 : item.lessonsplansLessons) === null || _c === void 0 ? void 0 : _c.length) || 0,
                        download: React.createElement(DownloadButton, { item: item, colorIcon: colorIconDownload })
                    };
                }
            });
            const sortedItems = items.sort((a, b) => {
                var _a, _b;
                const isADisabled = (_a = a.download.props.disabled) !== null && _a !== void 0 ? _a : false;
                const isBDisabled = (_b = b.download.props.disabled) !== null && _b !== void 0 ? _b : false;
                return Number(isADisabled) - Number(isBDisabled);
            });
            setDataLessonsPlans(sortedItems);
            setOriginalDataLessonsPlans(items);
        }
        setLoading(false);
    });
    const getDataLesson = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const response = yield manageLessonsPlans.findLessonPlansByLesson(idLesson);
        if (response) {
            const items = response.map(item => {
                var _a;
                return ({
                    id: item === null || item === void 0 ? void 0 : item.id,
                    name: item === null || item === void 0 ? void 0 : item.name,
                    description: item === null || item === void 0 ? void 0 : item.description,
                    Lessons: ((_a = item === null || item === void 0 ? void 0 : item.lessonsplansLessons) === null || _a === void 0 ? void 0 : _a.length) || 0,
                    download: React.createElement(DownloadButton, { item: item, colorIcon: colorIconDownload })
                });
            });
            setDataLessonsPlans(items);
            setOriginalDataLessonsPlans(items);
        }
        setLoading(false);
    });
    const handleOnSearch = (text) => {
        if (!text) {
            setDataLessonsPlans(originalDataLessonsPlans);
            return;
        }
        const filteredData = originalDataLessonsPlans.filter(item => {
            var _a, _b, _c, _d;
            return ((_b = (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(text === null || text === void 0 ? void 0 : text.toLowerCase())) ||
                ((_d = (_c = item === null || item === void 0 ? void 0 : item.description) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(text === null || text === void 0 ? void 0 : text.toLowerCase()));
        });
        setDataLessonsPlans(filteredData);
    };
    useEffect(() => {
        if (idLesson) {
            getDataLesson();
        }
        else if ((client === null || client === void 0 ? void 0 : client.id) && modules.length > 0) {
            getDataClient();
        }
    }, [modules.length]);
    return {
        dataLessonsPlans,
        originalDataLessonsPlans,
        loading,
        handleOnSearch
    };
};
export default useLessonPlans;
